<div class="dialog-header">
    <div class="title-container">
        <h1 mat-dialog-title>{{ "about" | transloco }}</h1>
    </div>
    <div class="logo"></div>
</div>

<mat-divider></mat-divider>

<mat-dialog-content>
    @if (hasError()) {
    <div class="version-info error">
        <span>{{ "failed_to_load_system_info" | transloco }}</span>
    </div>
    } @else if (systemInfo(); as info) {
    <div class="version-info">
        <div>
            <span>{{ "version" | transloco }}:</span>
            <span class="value"> {{ info.version }}@if (info.distance > 0) { <span class="distance"> (+{{ info.distance }} {{ "commits_ahead" | transloco }})</span>}</span>
        </div>
        <div>
            <span>{{ "commit" | transloco }}:</span>
            <span class="value"> {{ info.commitHash }}@if (info.isDirty) { <span class="dirty"> ({{ "dirty" | transloco }})</span>}</span>
        </div>
        <div>
            <span>{{ "branch" | transloco }}:</span>
            <span class="value"> {{ info.branch }}</span>
        </div>
        <div>
            <span>{{ "created_at" | transloco }}:</span>
            <span class="value"> {{ info.commitDate | date: "medium" }}</span>
        </div>
    </div>
    } @else {
    <div class="version-info loading">
        <div>
            <span>{{ "version" | transloco }}</span>
            <span class="value">:&nbsp;---</span>
        </div>
    </div>
    }
</mat-dialog-content>

<mat-divider></mat-divider>
<div
    mat-dialog-actions
    class="dialog-actions"
>
    <button
        mat-stroked-button
        type="button"
        (click)="copySystemInfo()"
        [disabled]="!systemInfo()"
    >
        <mat-icon>content_copy</mat-icon>
        {{ "copy_system_info" | transloco }}
    </button>
    <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="onClose()"
    >{{ "close" | transloco }}</button>
</div>
